function listenForWebmoneyPaymentTypeChange() {
  $('#webmoney_transaction_is_payout').on('change', function () {
    if ($(this).val() === 'true') {
      $('label[for="customer_account_id"]').addClass('required');
    } else {
      $('label[for="customer_account_id"]').removeClass('required');
    }
  });
}

var Webmoney = {
  listenForPaymentTypeChange: listenForWebmoneyPaymentTypeChange
};
export default Webmoney;